// Hero SVG Animation Controller
(function() {
  'use strict';

  class HeroAnimation {
    constructor(svgElement, options = {}) {
      this.svg = svgElement;
      this.options = {
        trigger: 'load', // 'load', 'scroll', or 'manual'
        scrollOffset: 0.75, // Trigger when 75% visible
        delay: 0,
        onComplete: null,
        ...options
      };
      
      this.init();
    }

    init() {
      // Add animation class
      this.svg.classList.add('hero-svg-animated');
      
      // Remove fixed dimensions to make responsive
      this.svg.removeAttribute('width');
      this.svg.removeAttribute('height');
      
      // Set up based on trigger type
      switch(this.options.trigger) {
        case 'load':
          this.startAnimation();
          break;
        case 'scroll':
          this.setupScrollTrigger();
          break;
        case 'manual':
          // Wait for manual trigger
          break;
      }
    }

    setupScrollTrigger() {
      this.svg.classList.add('animate-on-scroll');
      
      // Use Intersection Observer for better performance
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= this.options.scrollOffset) {
              this.startAnimation();
              observer.unobserve(this.svg);
            }
          });
        },
        {
          threshold: this.options.scrollOffset
        }
      );
      
      observer.observe(this.svg);
    }

    startAnimation() {
      setTimeout(() => {
        this.svg.classList.add('in-view');
        
        // Calculate total animation duration
        const totalDuration = 3300; // ~3.3 seconds for full animation
        
        if (this.options.onComplete) {
          setTimeout(this.options.onComplete, totalDuration);
        }
      }, this.options.delay);
    }

    reset() {
      this.svg.classList.remove('in-view');
      
      // Force reflow to restart animations
      void this.svg.offsetWidth;
    }

    play() {
      this.startAnimation();
    }
  }

  // Auto-initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    // Find all SVGs with data-hero-animation attribute
    const animatedSVGs = document.querySelectorAll('[data-hero-animation]');
    
    animatedSVGs.forEach(svg => {
      const trigger = svg.dataset.heroAnimation || 'load';
      const delay = parseInt(svg.dataset.animationDelay) || 0;
      
      new HeroAnimation(svg, {
        trigger: trigger,
        delay: delay,
        onComplete: () => {
          console.log('Hero animation complete');
          svg.classList.add('animation-complete');
        }
      });
    });
  });

  // Expose to global scope if needed
  window.HeroAnimation = HeroAnimation;
})();

// Example usage:
// 
// HTML:
// <svg data-hero-animation="scroll" data-animation-delay="500">...</svg>
// 
// Or programmatically:
// const svg = document.querySelector('.hero-svg');
// const animation = new HeroAnimation(svg, {
//   trigger: 'scroll',
//   scrollOffset: 0.5,
//   onComplete: () => console.log('Done!')
// });
// 
// // Manual control:
// animation.reset();
// animation.play();